<template>
    <div class="wrapper-change-password container">
        <div class="pt-5 pb-4">
            <div class="form-group form-goobank">
                <input class="form-control" v-validate="'required'" name="oldPassword" v-model="oldPassword" type="password" maxlength="30"
                :class="{ 'is-valid': (fields.oldPassword && fields.oldPassword.dirty) && !errors.has('oldPassword'), 'is-invalid': errors.has('oldPassword') }" />
                <label for="oldPassword">รหัสผ่านปัจจุบัน</label>
                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
            </div>
            <div class="form-group form-goobank">
                <input class="form-control" ref="newPassword" v-validate="'required'" name="newPassword" v-model="newPassword" type="password" maxlength="30"
                :class="{ 'is-valid': (fields.newPassword && fields.newPassword.dirty) && !errors.has('newPassword'), 'is-invalid': errors.has('newPassword') }" />
                <label for="newPassword">รหัสผ่านใหม่</label>
                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
            </div>
            <div class="form-group form-goobank">
                <input class="form-control" v-validate="'required|confirmed:newPassword'" name="confirmPassword" v-model="confirmPassword" type="password" maxlength="30"
                :class="{ 'is-valid': (fields.confirmPassword && fields.confirmPassword.dirty) && !errors.has('confirmPassword'), 'is-invalid': errors.has('confirmPassword') }" />
                <label for="confirmPassword">กรอกรหัสผ่านใหม่อีกครั้ง</label>
                <div class="invalid-feedback">รหัสผ่านไม่ตรงกัน</div>
            </div>
        </div>
        <div class="">
            <button class="btn btn-primary btn-lg btn-block" :disabled="isLoading" @click="updatePassword()">ยืนยันเปลี่ยนพาสเวิร์ด</button>
            <a :href="getUrl('member/home')" class="btn btn-light btn-lg btn-block">ย้อนกลับ</a>
        </div>
    </div>
</template>

<script>
import PathAvatarDefault from '../../../../assets/img/avatar.png';
import { setTimeout } from 'timers';
export default {
    data: () => ({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        isLoading: false,
    }),
    props: {
        baseUrl: '',
    },
    created () {
    },
    methods: {
        getUrl(pathName) {
            return `${this.baseUrl}/${pathName}`;
        },
        validateField() {
            return this.$validator.validateAll().then((result) => {
                return result;
            });
        },
        async updatePassword() {
            const isValid = await this.validateField();
            if (!isValid) {
                return;
            }
            const vm = this;
            const params = {
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                confirmPassword: this.confirmPassword,
            };
            this.isLoading = true;
            axios.post(this.getUrl('/member/api/change-password'),
                params
            ).then(({ data }) => {
                if (data.success) {
                    alert('เปลี่ยนรหัสผ่านเรียบร้อย');
                    window.location = this.getUrl('member/home');
                } else if (data.message) {
                    alert(data.message);
                }
            }).catch((error) => {
                console.log('error', error);
            }).then(() => {
                setTimeout(() => {
                    vm.isLoading = false;
                }, 300)
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    .img-avatar {
        display: block;
        margin: 1.5em auto 0;
        max-width: 300px;
        height: 300px;
        &.default-image {
            border-radius: 50%;
        }
    }
    label[disabled] {
        opacity: 0.5;
    }
</style>
